import { Base } from '@testsigma/organism';
import { deserialize, serializable } from 'serializr';
import { Platform } from '@modules/test-development/enums/platform.enum';

export class PlatformOsVersion extends Base {
  @serializable
  id: number;
  @serializable
  name: string;
  @serializable
  version: string;
  @serializable
  displayName: string;
  @serializable
  platform: Platform;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(PlatformOsVersion, input));
  }
}
